import React, { ComponentProps, useContext } from 'react'
import { Picker, PickerProps } from '@react-native-picker/picker'
import { useField } from 'formik'

import { Element } from '../Element'
import { FormFieldContext } from './FormField'
import { TokensContext } from '../context'

export type FormPickerProps = PickerProps & { testID?: string }

export const FormPicker = (props: FormPickerProps) => {
  const formFieldContext = useContext(FormFieldContext)
  const [field, _meta, helpers] = useField(formFieldContext.name)

  return (
    <Element
      {...props}
      as={Picker}
      component='FormPicker'
      selectedValue={field.value}
      ref={formFieldContext.formElementRef}
      onValueChange={(itemValue, itemIndex) => {
        const typedValue = itemValue as string | number
        try {
          if (props.onValueChange) {
            props.onValueChange(typedValue, itemIndex)
          }
        } finally {
          helpers.setValue(typedValue)
        }
      }}
    />
  )
}

export const FormPickerItem = ({
  color,
  ...props
}: ComponentProps<typeof Picker.Item>) => {
  const tokensContext = useContext(TokensContext)

  return (
    <Element
      {...props}
      style={{ fontFamily: 'Inter', fontWeight: '400' }}
      as={Picker.Item}
      color={color ?? tokensContext.color.grey[8]}
    />
  )
}
